import { shallowEqual, useSelector } from "react-redux";

const useGetSelectedPublication = () => {
  const selectedPublication = useSelector(state => state.UPFAssignReducer.selectedPublication, shallowEqual);
  return { selectedPublication };
}

export default useGetSelectedPublication;